import React, {Component} from 'react';
import { Link } from 'react-router';

export default class Hero extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isMobile: null,
    }
  }

  componentDidMount() {
      window.addEventListener("resize", this.resize.bind(this));
      this.resize();
  }

  resize() {
      this.setState({isMobile: window.innerWidth > 414});
  }

  render() {
    let { path } = this.props;
    let { isMobile } = this.state;
    console.log('path', path)

    let heroImageDesktop = "https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/moose_almighty_hero_desktop_3.jpg";
    let heroImageMobile = "https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/moose_almighty_hero_mobile_3.jpg";


  
    // let heroImageDesktop = null;
    // let heroImageMobile = null;

    // switch(path) {
    //   case '/store':
    //   case '/store/':
    //     heroImageDesktop = "https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/moose_almighty_hero_store_desktop.jpg";
    //     heroImageMobile = "https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/moose_almighty_hero_store_mobile.jpg";
    //     break;
    //   default:
    //     heroImageDesktop = "https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/moose_almighty_hero_desktop.jpg";
    //     heroImageMobile = "https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/moose_almighty_hero_mobile.jpg";
    // }

    return (
      <div className="Hero lozad" style={{backgroundImage: `url(${!isMobile ? heroImageMobile : heroImageDesktop})`}}>
        <div className="content_wrapper">
          {path === '/' ?
        	<div className="Hero__logo">
            <img className="lozad" src="https://blacksquare.nyc3.digitaloceanspaces.com/moose_almighty/moose_almighty/moose_almighty_logo_wordmark.png" alt="Moose Almighty" />
           </div>
           :
           null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Hero/Hero.js